import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setNotification } from "../../redux/slices/notificationSlice";
import { setBreakAsync } from "../../redux/slices/patrolsSlice";
import { Button, Box, Typography } from "@mui/material";
import { updateStatusAsync } from "../../redux/slices/patrolsSlice";
import { getRostersAsync } from "../../redux/slices/shiftsSlice";
import dayjs from "dayjs";
import ConfirmDialog from "./ConfirmDialog";

const PatrolManageStatus = ({ patrol, impersonatedUser }) => {

  const dispatch = useDispatch();
  const { resourceStatuses: pstatuses } = useSelector((state) => state.constants?.data);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const rosters = useSelector((state) => state.shifts.rosters);
  const [currentDuties, setCurrentDuties] = useState([]);
  let dutyTimer;
  const workingStatuses = ['FREE', 'PACK', 'HEAD', 'ARVD', 'RECY'];
  let userId = patrol?.id;
  if(impersonatedUser) {
    userId = impersonatedUser;
  }

  const handleStatusButton = async () => {
    if(workingStatuses.includes(patrol?.status.code) || patrol?.status.code == 'BRK') {
      await handleBreak();
    } else {
      await handleStatusChange();
    }
  }
  const handleBreak = async () => {
    if (patrol?.status.code != 'BRK') {
      try {
        const resp = await dispatch(setBreakAsync({
          entityId: userId,
          value: true,
        })).unwrap();
        if (resp.status == 200 || resp.status == 204) {
          dispatch(
            setNotification({ severity: 'success', message: 'Status is now BREAK.' })
          );
          dispatch({
            type: 'patrols/updateStatus',
            payload: { entityId: userId, value: pstatuses.find(s => s.code == 'BRK') }
          });
        }
      } catch (error) {
        dispatch(
          setNotification({ severity: 'error', message: 'Patrol status update error: ' + error.message })
        );
      }
    } else {
      try {
        const resp = await dispatch(setBreakAsync({
          entityId: userId,
          value: false,
        })).unwrap();
        if (resp.status == 200 || resp.status == 204) {
          dispatch(
            setNotification({ severity: 'success', message: 'BREAK ended.' })
          );
          dispatch({
            type: 'patrols/updateStatus',
            payload: { entityId: userId, value: patrol?.assignedTasks.length ? pstatuses.find(s => s.code == 'PACK') : pstatuses.find(s => s.code == 'FREE') }
          });
        }
      } catch (error) {
        dispatch(
          setNotification({ severity: 'error', message: 'Patrol status update error: ' + error.message })
        );
      }
    }
    handleCloseConfirmDialog();
  }

  useEffect(() => {
    if (patrol?.id) {
      dispatch(getRostersAsync(userId));
    }
  }, [patrol]);

  useEffect(() => {
    //pick current roster
    const nowLocal = dayjs();

    if (rosters.length) {
      const r = rosters.find(rosters => {
        return nowLocal.isAfter(rosters.effectiveDate) && nowLocal.isBefore(rosters.ineffectiveDate)
      });
      if (r) {
        //pick current duties
        processCurrentDuties(r);
        if (!dutyTimer) {
          //@TODO change to 5 minutes
          dutyTimer = setInterval(() => {
            processCurrentDuties(r);
          }, 30000);
        }

      } else {
        if (dutyTimer) {
          clearInterval(dutyTimer);
          dutyTimer = undefined;
        }
      }
    }
  }, [rosters]);

  const processCurrentDuties = (roster) => {
    const nowLocal = dayjs();
    const currentDuties = roster.duties.filter(d => {
      return dayjs(d.startTime).isSame(nowLocal, 'day') ||
        dayjs(d.finishTime).isSame(nowLocal, 'day') ||
        (nowLocal.isAfter(d.startTime, 'day') && nowLocal.isBefore(d.finishTime, 'day'));
    });
    setCurrentDuties(currentDuties);
  }

  const shouldSignOn = () => {
    let workingShifts = 0;
    const nowLocal = dayjs();

    if (currentDuties.length) {
      currentDuties.forEach(d => {
        if (d.dutyTypeCode == 'RSS' || d.dutyTypeCode == 'REL') {
          const start = dayjs(d.startTime);
          const end = dayjs(d.finishTime);
          if (
            (nowLocal.isAfter(start.subtract(30, 'minutes')) && nowLocal.isBefore(start))
            || (nowLocal.isBefore(end) && nowLocal.isAfter(start))
          ) {
            workingShifts++;
          }
        }
      });
    }
    return workingShifts > 0;
  }

  const handleCloseConfirmDialog = () => {
    setConfirmOpen(false);
  };

  const handleConfirmStatus = () => {
    handleStatusButton();
  }

  const handleStatusChange = async () => {
    if (patrol?.status.code == 'OFFD' || patrol?.status.code == 'UVOR') {
      try {
        const resp = await dispatch(updateStatusAsync({
          entityId: userId,
          value: 'FREE',
          impersonatedUser: impersonatedUser
        })).unwrap();

        if (resp.status == 200 || resp.status == 204) {
          dispatch(
            setNotification({ severity: 'success', message: 'Patrol status updated.' })
          );
        }
      } catch (error) {
        dispatch(
          setNotification({ severity: 'error', message: 'Patrol status update error: ' + error.message })
        );
      }
    } else {
      if (patrol?.status.code != 'OFFD' && patrol?.status.code != 'UVOR') {
        try {
          const resp = await dispatch(updateStatusAsync({
            entityId: userId,
            value: 'OFFD',
            impersonatedUser: impersonatedUser
          })).unwrap();

          if (resp.status == 200 || resp.status == 204) {
            dispatch(
              setNotification({ severity: 'success', message: 'Patrol status updated.' })
            );
          }
        } catch (error) {
          dispatch(
            setNotification({ severity: 'error', message: 'Patrol status update error: ' + error.message })
          );
        }
      }
    }
    handleCloseConfirmDialog();
  }

  const changeSignOnStatus = () => {
    if (patrol) {
      setConfirmOpen(true);
    }
  }

  const getMainButtonLabel = () => {
    
    if(patrol?.status.code == 'BRK') {
      return 'End BREAK';
    }

    if(workingStatuses.includes(patrol?.status.code)) {
      return 'Take a  break';
    }

    if(patrol?.status.code == 'BASE') {
      return 'Mark as OFFD';
    }

    if(patrol?.status.code == 'UVOR') {
      return 'END UVOR';
    }

    if(patrol?.status.code == 'OFFD' && shouldSignOn()) {
      return 'Mark as FREE';
    }

    if(patrol?.status.code == 'OFFD' && !shouldSignOn()) {
      return 'No working shifts.';
    }
  }

  return (
    <>
      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCloseConfirmDialog}
        title="Update status"
        cancelLabel="Cancel"
        cancelAction={handleCloseConfirmDialog}
        confirmLabel="Confirm"
        confirmAction={handleConfirmStatus}
      >
        <p>Are you sure you want to update your status?</p>
      </ConfirmDialog>
      <Box sx={{
        borderRadius: '16px',
        bgcolor: 'background.white',
        width: '92%',
        mx: 'auto',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Box sx={{
          width: '100%',
          mt: '20px',
          backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyLjE3NDYgNC41MTM1SDcuMTQ1NTlDNi44NzkxMSA0LjUxMzUgNi42NjMwOSA0LjcyOTUyIDYuNjYzMDkgNC45OTZWMzMuOTg3QzYuNjYzMDkgMzQuMjUzNSA2Ljg3OTExIDM0LjQ2OTUgNy4xNDU1OSAzNC40Njk1SDMyLjE3NDZDMzIuNDQxMSAzNC40Njk1IDMyLjY1NzEgMzQuMjUzNSAzMi42NTcxIDMzLjk4N1Y0Ljk5NkMzMi42NTcxIDQuNzI5NTIgMzIuNDQxMSA0LjUxMzUgMzIuMTc0NiA0LjUxMzVaIiBmaWxsPSIjRkZEMzAwIi8+CjxwYXRoIGQ9Ik0xOS42NjMgMTkuNDg4NUMyMy41MDggMTkuNDg4NSAyNi42MzY1IDE2LjM2MDUgMjYuNjM2NSAxMi41MTVDMjYuNjM2NSA4LjY2OTUgMjMuNTA4NSA1LjU0MTUgMTkuNjYzIDUuNTQxNUMxNS44MTc1IDUuNTQxNSAxMi42ODk1IDguNjY5NSAxMi42ODk1IDEyLjUxNUMxMi42ODk1IDE2LjM2MDUgMTUuODE3NSAxOS40ODg1IDE5LjY2MyAxOS40ODg1Wk0xOS42NjMgNy41NDE1QzIyLjQwNTUgNy41NDE1IDI0LjYzNjUgOS43NzI1IDI0LjYzNjUgMTIuNTE1QzI0LjYzNjUgMTUuMjU3NSAyMi40MDU1IDE3LjQ4ODUgMTkuNjYzIDE3LjQ4ODVDMTYuOTIwNSAxNy40ODg1IDE0LjY4OTUgMTUuMjU3NSAxNC42ODk1IDEyLjUxNUMxNC42ODk1IDkuNzcyNSAxNi45MjA1IDcuNTQxNSAxOS42NjMgNy41NDE1WiIgZmlsbD0iIzAwMDgxQyIvPgo8cGF0aCBkPSJNMzQuMzI3OCAzMy4xNTg1QzM0LjMyMjggMzIuNjc3IDM0LjMxNzggMzIuMjIxNSAzNC4zMTc4IDMxLjg4QzM0LjMxNzggMjguODI2NSAzMy4xMjg4IDI1Ljk1NiAzMC45Njk4IDIzLjc5N0MyOC44MTA4IDIxLjYzOCAyNS45Mzk4IDIwLjQ0OSAyMi44ODYzIDIwLjQ0OUgxNy4yMDEzQzE0LjE3MDggMjAuNDQ5IDExLjI0MzMgMjEuNjEzIDkuMDg2MjcgMjMuNzQxNUM2Ljg5MTc4IDI1LjkwNyA1LjY4MTc4IDI4LjgwMDUgNS42ODE3OCAzMS44ODA1QzUuNjgxNzggMzIuMjIyNSA1LjY3Njc4IDMyLjY3NzUgNS42NzE3OCAzMy4xNTlDNS42NjUyOCAzMy43NjE1IDUuNjU4MjggMzQuNDI1IDUuNjU5MjggMzQuOTk2QzUuNjU5NzggMzUuMjc0NSA1Ljg4ODI4IDM1LjQ5ODUgNi4xNjY3OCAzNS40OTQ1TDcuMTY2NzggMzUuNDhDNy40NDA3OCAzNS40NzYgNy42NTk3OCAzNS4yNTMgNy42NTkyOCAzNC45NzlDNy42NTgyOCAzNC40MjQgNy42NjUyOCAzMy43NzIgNy42NzE3OCAzMy4xODA1QzcuNjc3MjggMzIuNjkzNSA3LjY4MTc4IDMyLjIzMzUgNy42ODE3OCAzMS44ODA1QzcuNjgxNzggMjYuNjggMTEuOTEyOCAyMi40NDkgMTcuMTEzMyAyMi40NDlIMjIuODg2M0MyOC4wODY4IDIyLjQ0OSAzMi4zMTc4IDI2LjY4IDMyLjMxNzggMzEuODgwNUMzMi4zMTc4IDMyLjIzMyAzMi4zMjI4IDMyLjY5MzUgMzIuMzI3OCAzMy4xODFDMzIuMzM0MyAzMy43NzI1IDMyLjM0MTMgMzQuNDI0NSAzMi4zNDAzIDM0Ljk3OUMzMi4zNDAzIDM1LjI1MyAzMi41NTkzIDM1LjQ3NiAzMi44MzI4IDM1LjQ4TDMzLjgzMjggMzUuNDk0NUMzNC4xMTEzIDM1LjQ5ODUgMzQuMzM5MyAzNS4yNzQ1IDM0LjM0MDMgMzQuOTk2QzM0LjM0MTMgMzQuNDI1IDM0LjMzNDMgMzMuNzYxNSAzNC4zMjc4IDMzLjE1OVYzMy4xNTg1WiIgZmlsbD0iIzAwMDgxQyIvPgo8L3N2Zz4K')",
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '4% 50%',
          paddingLeft: '60px',
        }}>
          <Typography sx={{ fontSize: '24px', color: 'background.black', fontWeight: 700 }}>Patrol status</Typography>
        </Box>
        <Box sx={{
          width: '100%',
          marginTop: '25px',
          pb: '25px',
          display: 'flex',
          alignContent: 'center'
        }}>
          {patrol?.status.code == 'OFFD' && shouldSignOn()}
          <Button
            onClick={changeSignOnStatus}
            variant={(patrol?.status.code == 'OFFD' && shouldSignOn()) ? "green" : "outlined"}
            sx={{
              width: '92%',
              mx: 'auto'
            }}>
            {getMainButtonLabel()}
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default PatrolManageStatus;